const AppConstants = {
  rowsPerPage: 20,
  rowsPerPageOptions: [20, 50, 100],
};

export default AppConstants;
